import { useEffect, useState } from "react";
import { apiFetchPublic } from "../lib/api";
import { heroPhotoToShowcasePhoto } from "../lib/homeHeroPhotos";

/** @typedef {ReturnType<typeof heroPhotoToShowcasePhoto>} ShowcasePhoto */

/** @returns {{ photos: ShowcasePhoto[], loading: boolean }} */
export function useShowcasePhotos() {
  const [photos, setPhotos] = useState(/** @type {ShowcasePhoto[] | null} */ (null));

  useEffect(() => {
    let cancelled = false;

    async function loadPhotos() {
      try {
        const body = await apiFetchPublic("/home-hero-photos");
        const apiPhotos = body.data?.photos || [];

        if (!cancelled) {
          setPhotos(apiPhotos.map(heroPhotoToShowcasePhoto));
        }
      } catch {
        if (!cancelled) {
          setPhotos([]);
        }
      }
    }

    void loadPhotos();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    photos: photos ?? [],
    loading: photos === null,
  };
}
